import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BusComponent from '../BusComponent';
import googleTagManagerEvents from '../../helpers/GoogleTagManagerEventsWrapper';
import { saveProjectEvents } from '../../enums/GoogleTagManagerEvents';

const SaveProjectButton = googleTagManagerEvents('button', saveProjectEvents);

class SaveButton extends BusComponent {
    componentDidMount() {
        this.setGTMAttributes();
    }

    componentDidUpdate() {
        this.setGTMAttributes();
    }

    setGTMAttributes = () => {
        if (this.props.showSave) {
            this.saveButton.setCustomAttribute('gtm-eventc', 'Map projects');
            this.saveButton.setCustomAttribute('gtm-eventl', this.props.projectTitle);
        }
    };

    onSaveProjectClick = () => {
        const { isEdit } = this.props;

        const eventName = isEdit ? 'EDIT_PROJECT_POPUP_REQUEST' : 'SAVE_PROJECT_POPUP_REQUEST';
        this.emit(eventName);
    };

    render() {
        const { buttonVariant } = this.props;

        const buttonClasses = classNames(
            {
                'btn-raised': buttonVariant === 'raised',
            },
            {
                'btn-flat': buttonVariant === 'flat',
            },
            {
                'btn-flat--light': buttonVariant === 'flat',
            },
            'application-header__button',
        );

        return (
            <SaveProjectButton
                ref={c => {
                    this.saveButton = c;
                }}
                className={buttonClasses}
                onClick={this.onSaveProjectClick}
                data-testid="header-save-map"
            >
                {`${this.props.intl.formatMessage({ id: 'header.saveMap' })}`}
            </SaveProjectButton>
        );
    }
}

SaveButton.propTypes = {
    projectTitle: PropTypes.string,
    isEdit: PropTypes.bool,
    buttonVariant: PropTypes.string,
    intl: PropTypes.object.isRequired,
};

SaveButton.defaultProps = {
    projectTitle: undefined,
    isEdit: false,
    buttonVariant: 'raised',
};

export default injectIntl(SaveButton);
